export const MARKETING_PREVIEW_NAV = [
  {
    id: 'preview-meet-scores',
    label: 'WCS & PR',
    shortLabel: 'Scores',
  },
  {
    id: 'preview-expert-ratings',
    label: 'Expert Ratings',
    shortLabel: 'Ratings',
  },
  { id: 'preview-hot-picks', label: 'Hot Picks', shortLabel: 'Hot Picks' },
  { id: 'preview-analytics', label: 'Analytics', shortLabel: 'Analytics' },
] as const;

/** Offset for sticky navbar + quick-nav when scrolling to anchors. */
export const MARKETING_PREVIEW_SCROLL_MARGIN = {
  base: '11.5rem',
  md: '10rem',
} as const;
